import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { commonService } from "../../../utils/commonService";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const percentagePlugin = {
  id: "percentagePlugin",
  afterDatasetsDraw(chart, args, pluginOptions) {
    const { ctx, data } = chart;
    ctx.save();

    data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      if (!meta.hidden && !dataset.hidden) {
        meta.data.forEach((datapoint, index) => {
          const value = dataset.data[index];
          const total = dataset.data.reduce((a, b) => a + b, 0);
          const percentage =
            total > 0 ? Math.round((value / total) * 100) + "%" : "0%";

          if (value > 0) {
            ctx.font = "bold 12px sans-serif";
            ctx.fillStyle = dataset.backgroundColor || "#e88904";
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";
            ctx.fillText(percentage, datapoint.x, datapoint.y - 5);
          }
        });
      }
    });

    ctx.restore();
  },
};

const BookingWindowNext30dArrivals = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    BookingWindowNext30dArrivalsTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [dataObj, setDataObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [hiddenDatasets, setHiddenDatasets] = useState({
    thisYear: false,
    lastYear: false,
  });

  useEffect(() => {
    if (api === 0) {
      setDataObj({
        BW0_RMS: 12,
        BW1_RMS: 18,
        BW2TO7_RMS: 45,
        BW8TO15_RMS: 60,
        BW16TO30_RMS: 85,
        BW31TO60_RMS: 70,
        BW61TO90_RMS: 40,
        BW91TOUP_RMS: 25,
        BW0_LYRMS: 10,
        BW1_LYRMS: 15,
        BW2TO7_LYRMS: 40,
        BW8TO15_LYRMS: 55,
        BW16TO30_LYRMS: 75,
        BW31TO60_LYRMS: 65,
        BW61TO90_LYRMS: 35,
        BW91TOUP_LYRMS: 20,
      });
      setLoading(false);
    } else {
      if (para?.propertyCode && para?.asOfDate) {
        getDbdStlyData();
      }
    }
  }, [para, api]);

  const getDbdStlyData = async () => {
    setLoading(true);
    const startDate = commonService.getDateForNode(
      commonService.convertDateInTimezone(new Date()),
    );

    let dbdStlyResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.BOOKING_WINDOW.DAY_BY_DAY_STLY,
        body: {
          AsOfDate: para?.asOfDate,
          startDate: startDate,
          endDate: moment(startDate).add(30, "days").format("YYYY-MM-DD"),
          propertyCode: para?.propertyCode,
        },
      },
      false,
    );

    let response = apiResponse(false, dbdStlyResponse);

    if (response?.isValidate) {
      const responseData = response?.data?.data;
      const finalData =
        Array.isArray(responseData) && responseData.length > 0
          ? responseData[0]
          : responseData || {};
      setDataObj(finalData);
      setLoading(false);
    } else {
      setDataObj({});
      setLoading(false);
    }
  };

  const toggleDataset = (datasetKey) => {
    if (api === 0) return;
    setHiddenDatasets((prev) => ({
      ...prev,
      [datasetKey]: !prev[datasetKey],
    }));
  };

  //   const dataObj = data && data.length > 0 ? data[0] : {};

  const labels = [
    "0d",
    "1d",
    "2-7d",
    "8-15d",
    "16-30d",
    "31-60d",
    "61-90d",
    "91d+",
  ];

  const thisYearData = [
    dataObj.BW0_RMS || 0,
    dataObj.BW1_RMS || 0,
    dataObj.BW2TO7_RMS || 0,
    dataObj.BW8TO15_RMS || 0,
    dataObj.BW16TO30_RMS || 0,
    dataObj.BW31TO60_RMS || 0,
    dataObj.BW61TO90_RMS || 0,
    dataObj.BW91TOUP_RMS || 0,
  ];

  const lastYearData = [
    dataObj.BW0_LYRMS || 0,
    dataObj.BW1_LYRMS || 0,
    dataObj.BW2TO7_LYRMS || 0,
    dataObj.BW8TO15_LYRMS || 0,
    dataObj.BW16TO30_LYRMS || 0,
    dataObj.BW31TO60_LYRMS || 0,
    dataObj.BW61TO90_LYRMS || 0,
    dataObj.BW91TOUP_LYRMS || 0,
  ];

  const chartData = {
    labels,
    datasets: [
      {
        label: "CY",
        data: thisYearData,
        backgroundColor: "#e88904", // Orange from the image
        borderRadius: 2,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
        hidden: hiddenDatasets.thisYear,
      },
      {
        label: "STLY",
        data: lastYearData,
        backgroundColor: "#4e5a6a", // Gray/blue from the image
        borderRadius: 2,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
        hidden: hiddenDatasets.lastYear,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 25,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        titleColor: "#0f172a",
        bodyColor: "#475569",
        borderColor: "#e2e8f0",
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#64748b",
          font: {
            family: "monospace",
            size: 12,
          },
        },
        border: {
          display: false,
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
      },
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID("BookingWindowNext30dArrivals","emailIcon", propertyDetailFromRTK?.propertyid)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.BookingWindowNext30dArrivalsTable,
                  "BookingWindowNext30dArrivals",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId,
                );
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "BookingWindowNext30dArrivals",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName:
                    compName?.BookingWindowNext30dArrivals ||
                    "BookingWindowNext30dArrivals",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("BookingWindowNext30dArrivals","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.BookingWindowNext30dArrivalsTable,
                  `${para?.propertyCode}-BookingWindowNext30dArrivals-${moment(new Date()).format("MMDDYYYY")}`,
                )
              }
            />
          </Button> */}
        </div>
      )}
      <div className="stly-booking-container">
        <div className="stly-chart-wrapper">
          <Bar
            data={chartData}
            options={options}
            plugins={[percentagePlugin]}
          />
        </div>

        <div className="stly-bottom-section">
          {/* <div className="stly-monospace-text">
          Window lengthening: 31-60d up 6pts YoY — planners with lower price
          sensitivity
        </div> */}
          <div className="stly-legend-wrapper">
            <div
              className={`stly-legend-item ${hiddenDatasets.thisYear ? "hidden" : ""}`}
              style={{ cursor: api === 0 ? "default" : "pointer" }}
              onClick={() => toggleDataset("thisYear")}
            >
              <div className="stly-legend-color-box this-year"></div>
              <span className="stly-legend-text">CY</span>
            </div>
            <div
              className={`stly-legend-item ${hiddenDatasets.lastYear ? "hidden" : ""}`}
              style={{ cursor: api === 0 ? "default" : "pointer" }}
              onClick={() => toggleDataset("lastYear")}
            >
              <div className="stly-legend-color-box last-year"></div>
              <span className="stly-legend-text">STLY</span>
            </div>
          </div>
        </div>
      </div>
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={
            "BookingWindowNext30dArrivals" +
            tblids.BookingWindowNext30dArrivalsTable
          }
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default BookingWindowNext30dArrivals;
